const CAMINHO_VISUALIZADOR = "/documento/visualizar";

export async function AbrirDocumento(blob: Blob, headers: Headers) {
  const contentType = headers.get("Content-Type") || "";
  const url = URL.createObjectURL(blob);

  if (contentType.includes("pdf")) {
    window.open(url, "_blank");
  } else if (contentType.includes("tiff") || contentType.includes("tif")) {
    const parametros = new URLSearchParams({ src: url, mime: contentType });
    window.open(`${CAMINHO_VISUALIZADOR}?${parametros.toString()}`, "_blank");
  }

  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
